(() => {
  const initSlider = (slider) => {
    if (!slider || slider.dataset.wombatSliderReady === 'true') return;

    const slides = Array.from(slider.querySelectorAll('[data-wombat-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-wombat-dot]'));
    const status = slider.querySelector('[data-wombat-status]');
    const previous = slider.querySelector('[data-wombat-prev]');
    const next = slider.querySelector('[data-wombat-next]');
    const toggle = slider.querySelector('[data-wombat-toggle]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let paused = reduceMotion;
    let current = 0;
    let timer;
    let touchStartX = null;

    if (slides.length < 2) return;
    slider.dataset.wombatSliderReady = 'true';

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button, input, select, textarea').forEach((control) => {
          if (active) control.removeAttribute('tabindex');
          else control.setAttribute('tabindex', '-1');
        });
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (status) status.textContent = `第 ${current + 1} 張，共 ${slides.length} 張`;
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!paused) timer = window.setInterval(() => show(current + 1), 3000);
    };

    const updateToggle = () => {
      if (!toggle) return;
      toggle.textContent = paused ? '播放' : '暫停';
      toggle.setAttribute('aria-label', paused ? '播放自動輪播' : '暫停自動輪播');
    };
    toggle?.addEventListener('click', () => {
      paused = !paused;
      updateToggle();
      start();
    });

    previous?.addEventListener('click', () => { show(current - 1); start(); });
    next?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    slider.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      if (Math.abs(distance) > 45) show(current + (distance < 0 ? 1 : -1));
      touchStartX = null;
      start();
    }, { passive: true });

    show(0);
    updateToggle();
    start();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-wombat-slider]').forEach(initSlider);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
